<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="improvedSurveys"
        @update:filter="reset"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button type="primary" @click="$refs.editPage.open(0)">新建</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcel()">导出</el-button>
        <el-button type="primary" :loading="exportLoading" @click="exportExcelOld()">导出QMS 2.0</el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="投诉编号">
            <el-input v-model.trim="filter.billNo" clearable/>
          </vm-search>
          <vm-search label="投诉日期">
            <el-date-picker
                v-model="complaintDate"
                :picker-options="pickerOptions"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="complaintDateChange"/>
          </vm-search>
          <vm-search label="流程状态">
            <el-select v-model.trim="filter.flowStatus" clearable placeholder="请选择流程状态">
              <el-option label="cqe初审" :value="10"/>
              <el-option label="改进措施" :value="20"/>
              <el-option label="改进措施复审" :value="30"/>
              <el-option label="cqe复审" :value="40"/>
              <el-option label="改进措施提交" :value="50"/>
              <el-option label="改进措施验证" :value="60"/>
              <el-option label="首单验证" :value="70"/>
              <el-option label="已完成" :value="80"/>
            </el-select>
          </vm-search>
          <vm-search label="出厂编号">
            <el-input v-model.trim="filter.factoryNo" clearable/>
          </vm-search>
          <vm-search label="更换单号">
            <el-input v-model.trim="filter.csno" clearable/>
          </vm-search>
          <vm-search label="客户名称">
            <el-input v-model.trim="filter.customerName" clearable/>
          </vm-search>
          <vm-search label="反馈人员">
            <el-input v-model.trim="filter.creatorName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="billNo" align="center" label="投诉编号">
        <template slot-scope="scope">
          <div style="color: #2d8cf0; cursor: pointer" @click="goto(scope.row)">{{scope.row.billNo}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="factoryNo" width="200" align="center" label="出厂编号"/>
      <el-table-column prop="complaintDate" width="100" align="center" label="投诉日期"/>
      <el-table-column prop="customerName" width="250" align="center" label="客户名称"/>
      <el-table-column prop="nodeDesc" align="center" label="当前节点">
        <template slot-scope="scope">
          <span v-if="scope.row.nodeDesc===null && scope.row.status>0">已完成</span>
          <span v-else>{{scope.row.nodeDesc}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="handlerName" width="100" align="center" label="节点处理人"/>
      <el-table-column prop="problemDesc" width="400" align="center" label="问题描述"/>
      <el-table-column prop="csno" align="center" label="关联单号"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px">
        <template slot-scope="scope">
          <el-button type="primary" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.status===0" type="primary" @click="submit(scope.row.pkid)">提交</el-button>
          <el-button v-if="scope.row.status===0 || delAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <improved-survey-edit ref="editPage" @save-success="getList(1)"/>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import ImprovedSurveyEdit from "@/views/purchase/ImprovedSurvey/ImprovedSurveyEdit";

  export default {
    name: "ImprovedSurveyList",
    components: {ImprovedSurveyEdit, VmTable, VmSearch},
    data() {
      return {
        delAuth: this.$auth(891),
        idList: "",
        exportLoading: false,
        pickerOptions: {
          shortcuts: [{
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          }, {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          }],
        },
        complaintDate: "",
        filter: {
          billNo: "",
          factoryNo: "",
          customerName: "",
          complaintDateBegin: "",
          complaintDateEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      reset() {
        this.complaintDate = "";
        this.filter.complaintDateBegin = "";
        this.filter.complaintDateEnd = "";
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      complaintDateChange(date) {
        if (date !== null) {
          this.filter.complaintDateBegin = date[0];
          this.filter.complaintDateEnd = date[1];
        } else {
          this.filter.complaintDateBegin = "";
          this.filter.complaintDateEnd = "";
        }
      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "improvedSurveys/exportImprovedSurvey", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      exportExcelOld() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "replacementBills/exportGX", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", {type: "warning"}).then(() => {
          this.$http.get("basic", "improvedSurveys/submit/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      goto(row) {
        this.$router.push({
          path: "/ImprovedSurvey",
          query: {
            billType: 28,
            billId: row.pkid,
            $tabName: row.billNo,
          },
        });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "improvedSurveys", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>

<style scoped>

</style>
